import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AdminSearchResultsModel } from './admin-search-results.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AdminSearchService = /** @class */ (function () {
    function AdminSearchService(http) {
        this.http = http;
        this.adminSearchUrl = 'dealers/';
    }
    AdminSearchService.prototype.performSearch = function (searchParams) {
        var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.get(this.adminSearchUrl, { params: searchParams, headers: headers }).pipe(map(function (response) {
            return response ? response.map(function (element) { return AdminSearchResultsModel.fromJSON(element); }) : null;
        }));
    };
    AdminSearchService.ngInjectableDef = i0.defineInjectable({ factory: function AdminSearchService_Factory() { return new AdminSearchService(i0.inject(i1.HttpClient)); }, token: AdminSearchService, providedIn: "root" });
    return AdminSearchService;
}());
export { AdminSearchService };
